<template>
  <WelcomeHeader />
  <GuidelineNav current="science" />

  <!-- ═══ HERO ═══ -->
  <section class="hero-section">
    <div class="hero-noise"></div>
    <div class="container hero-inner">
      <div class="hero-badge">বিসিএস প্রস্তুতি গাইড · সংস্করণ ৪.০</div>
      <h1 class="hero-title">সাধারণ বিজ্ঞান <span class="hero-accent">গাইডলাইন</span></h1>
      <p class="hero-sub">বিসিএস ৩৫ থেকে ৫০ পর্যন্ত সম্পূর্ণ টপিকভিত্তিক প্রশ্ন বিশ্লেষণ</p>
      <div class="hero-stats">
        <div class="hstat"><div class="hstat-num">১৫</div><div class="hstat-lbl">মোট মার্ক</div></div>
        <div class="hstat-sep"></div>
        <div class="hstat"><div class="hstat-num">০৫</div><div class="hstat-lbl">ভৌত বিজ্ঞান</div></div>
        <div class="hstat-sep"></div>
        <div class="hstat"><div class="hstat-num">০৫</div><div class="hstat-lbl">জীববিজ্ঞান</div></div>
        <div class="hstat-sep"></div>
        <div class="hstat"><div class="hstat-num">০৫</div><div class="hstat-lbl">আধুনিক বিজ্ঞান</div></div>
        <div class="hstat-sep"></div>
        <div class="hstat"><div class="hstat-num">৯ লাখ+</div><div class="hstat-lbl">অ্যাপ ডাউনলোড</div></div>
      </div>
    </div>
  </section>

  <!-- ═══ MARKS BREAKDOWN ═══ -->
  <div class="marks-bar">
    <div class="container">
      <div class="marks-header">মার্ক বিভাজন (মোট = ১৫)</div>
      <div class="marks-grid">
        <div class="mk-item"><div class="mk-num">০৫</div><div class="mk-lbl">ভৌত বিজ্ঞান</div></div>
        <div class="mk-item"><div class="mk-num">০৫</div><div class="mk-lbl">জীববিজ্ঞান</div></div>
        <div class="mk-item"><div class="mk-num">০৫</div><div class="mk-lbl">আধুনিক বিজ্ঞান</div></div>
      </div>
    </div>
  </div>

  <!-- ═══ LEGEND BAR ═══ -->
  <div class="legend-bar">
    <div class="legend-inner">
      <span class="legend-label">হিটম্যাপ স্কেল:</span>
      <span class="lc h0">০</span>
      <span class="lc h1">১</span>
      <span class="lc h2">২</span>
      <span class="lc h3">৩+</span>
      <span class="legend-sep">|</span>
      <span class="pri-tag p3">★★★ অবশ্যই</span>
      <span class="pri-tag p2">★★ গুরুত্বপূর্ণ</span>
      <span class="pri-tag p1">★ এক নজর</span>
    </div>
  </div>

  <!-- ═══ MAIN ═══ -->
  <section class="main-section">
    <div class="container">
      <div class="tab-content">
        <!-- Bar Chart -->
        <div class="chart-card">
          <h3 class="chart-title">শীর্ষ টপিক — মোট প্রশ্নসংখ্যা (বিসিএস ৩৫–৫০)</h3>
          <div class="bar-list">
            <div v-for="row in allChart" :key="row.topic" class="bar-row">
              <div class="bar-label">{{ row.topic }}</div>
              <div class="bar-track">
                <div class="bar-fill" :style="{ width: (row.total / 26 * 100) + '%' }" :class="'bp' + row.priority"></div>
              </div>
              <div class="bar-val">{{ toBengali(row.total) }}</div>
            </div>
          </div>
        </div>

        <!-- Heatmap -->
        <div class="section-head">
          <h2>টপিকভিত্তিক প্রশ্ন হিটম্যাপ</h2>
          <p>বিসিএস ৩৫ থেকে ৫০ পর্যন্ত প্রতিটি বিসিএসে কতটি প্রশ্ন এসেছে</p>
        </div>
        <div class="table-wrap">
          <table class="heat-table">
            <thead>
              <tr>
                <th class="t-topic">টপিক</th>
                <th>৩৫</th><th>৩৬</th><th>৩৭</th><th>৩৮</th>
                <th>৪০</th><th>৪১</th><th>৪৩</th><th>৪৪</th><th>৪৫</th>
                <th class="t-new">৪৬</th><th class="t-new">৪৭</th><th class="t-new">৫০</th>
                <th class="t-total">মোট</th>
                <th class="t-pri">গুরুত্ব</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in allData" :key="row.topic">
                <td class="t-name">{{ row.topic }}</td>
                <td v-for="(val, i) in row.values" :key="i" :class="heatClass(val)">{{ val > 0 ? toBengali(val) : '' }}</td>
                <td class="t-total-cell">{{ toBengali(row.total) }}</td>
                <td class="t-pri-cell"><span :class="'pb p' + row.priority">{{ priorityLabel(row.priority) }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Insight Cards -->
        <div class="insight-grid">
          <div class="ins-card must">
            <div class="ins-head">★★★ অবশ্যই পড়তে হবে</div>
            <ul>
              <li>মানব দেহের অঙ্গ ও তন্ত্র</li>
              <li>মাইক্রোবায়োলজি, রোগ ও স্বাস্থ্য</li>
              <li>পৃথিবী ও মহাবিশ্ব</li>
              <li>জৈব ও অজৈব যৌগ</li>
              <li>বলবিদ্যা, শক্তির উৎস ও পরিমাপ</li>
              <li>তড়িৎ</li>
              <li>পরমাণুর গঠন (এটমের গঠন)</li>
              <li>রাসায়নিক বিক্রিয়া</li>
              <li>ইলেক্ট্রনিক্স</li>
            </ul>
          </div>
          <div class="ins-card imp">
            <div class="ins-head">★★ গুরুত্বপূর্ণ</div>
            <ul>
              <li>মানব কল্যাণে রসায়ন</li>
              <li>এসিড, ক্ষার ও লবণ</li>
              <li>আলোক শক্তি ও যন্ত্রপাতি</li>
              <li>ভৌত বিজ্ঞানের উন্নয়ন</li>
              <li>তাপ ও তাপগতিবিদ্যা</li>
              <li>মৌলিক কণা</li>
              <li>উদ্ভিদের শারীরবৃত্তীয় কাজ</li>
            </ul>
          </div>
          <div class="ins-card low">
            <div class="ins-head">★ এক নজর দেখুন</div>
            <ul>
              <li>তরঙ্গ ও শব্দ</li>
              <li>কোষ</li>
              <li>জীব জগৎ</li>
              <li>টিস্যু</li>
              <li>চৌম্বকত্ব</li>
              <li>পদার্থের অবস্থা</li>
              <li>ভৌত রাশি ও পরিমাপ</li>
              <li>পদার্থের জীববিজ্ঞান বিষয়ক ধর্ম</li>
            </ul>
          </div>
        </div>

        <!-- Combined Analysis -->
        <div class="analysis-box">
          <h4>📊 বিশ্লেষণ</h4>
          <p>সাধারণ বিজ্ঞানের বিগত বছরের প্রশ্ন এনালাইসিস করলে দেখা যায়, বিশেষ করে ৩৫ বিসিএস থেকে ৫০ পর্যন্ত — <strong>জৈব ও অজৈব যৌগ, বলবিদ্যা ও শক্তির উৎস, তড়িৎ, মানব দেহের অঙ্গ ও তন্ত্র, পৃথিবী ও মহাবিশ্ব, মাইক্রোবায়োলজি-রোগ ও স্বাস্থ্য, রাসায়নিক বিক্রিয়া, পরমাণুর গঠন ও ইলেক্ট্রনিক্স</strong> — এই টপিকগুলো থেকে প্রায় প্রতিবছরই অনেকগুলো করে প্রশ্ন আসে। তাই এগুলো মোস্ট ইম্পরট্যান্ট, খুব ভালোভাবে পড়তে হবে।</p>
          <p><strong>ভৌত বিজ্ঞানের উন্নয়ন, জীব জগৎ, পদার্থের জীববিজ্ঞান বিষয়ক ধর্ম, কোষ, টিস্যু, চৌম্বকত্ব, পদার্থের অবস্থা, তরঙ্গ ও শব্দ</strong> — এই টপিকগুলো থেকে তুলনামূলক কম প্রশ্ন আসে (বিশেষ করে ৩৫ বিসিএসের পর থেকে)। তাই এগুলো কম গুরুত্বপূর্ণ, তবে একদম বাদ দেওয়া যাবে না।</p>
          <p class="mb-0"><strong>একটি গুরুত্বপূর্ণ কথা:</strong> বিজ্ঞানে এভাবে টপিক সাজেশন করে পড়া পুরোপুরি সম্ভব নয় — কারণ প্রতি বিসিএসেই কোনো না কোনো টপিক থেকে প্রশ্ন আসে। তাই সম্ভব হলে সব টপিকই ভালোভাবে পড়ার চেষ্টা করুন। পদার্থবিজ্ঞান, জীববিজ্ঞান বা রসায়ন থেকে শুধুমাত্র প্রাসঙ্গিক টপিকগুলো পড়লেই চলবে — পুরো বই পড়ার দরকার নেই।</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ═══ FREE PDF OPT-IN ═══ -->
  <GuidelineOptin subject="science" pdf="https://www.bcsprostuti.com/api5/storage/pdfs/BCS-Science-Guideline-1_2026_06_20_14_22_38.pdf" />

  <!-- ═══ REFERENCE BOOKS ═══ -->
  <section class="ref-section">
    <div class="container">
      <div class="section-head center">
        <h2>রেফারেন্স বই</h2>
        <p>পরীক্ষায় ভালো করার জন্য এই বইগুলো অনুসরণ করুন (শুধু প্রাসঙ্গিক অধ্যায়)</p>
      </div>
      <div class="book-grid">
        <div class="book-card" v-for="b in refBooks" :key="b.title">
          <div class="book-spine"></div>
          <div class="book-info">
            <div class="book-title">{{ b.title }}</div>
            <div class="book-author">{{ b.author }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═══ TIPS ═══ -->
  <section class="tips-section">
    <div class="container">
      <div class="section-head center">
        <h2>পরামর্শ ও কৌশল</h2>
        <p>কীভাবে সাধারণ বিজ্ঞানে সর্বোচ্চ নম্বর তুলবেন</p>
      </div>
      <div class="tips-grid">
        <div class="tip-card" v-for="(tip, i) in tips" :key="i">
          <div class="tip-num">{{ toBengali(i + 1) }}</div>
          <p class="tip-text">{{ tip }}</p>
        </div>
      </div>
    </div>
  </section>

  <GuidelineRelated current="science" />

  <!-- ═══ CTA ═══ -->
  <section class="cta-section">
    <div class="container">
      <div class="cta-grid">
        <div class="cta-left">
          <div class="cta-tag">বিসিএস প্রস্তুতি অ্যাপ</div>
          <h2 class="cta-title">সাধারণ বিজ্ঞানে সর্বোচ্চ নম্বর তুলুন</h2>
          <ul class="cta-features">
            <li><span class="cf-icon">✓</span> টপিকভিত্তিক প্রশ্ন ব্যাঙ্ক ও ব্যাখ্যা</li>
            <li><span class="cf-icon">✓</span> বিগত ৩৫–৫০ বিসিএসের সম্পূর্ণ প্রশ্নসমূহ</li>
            <li><span class="cf-icon">✓</span> স্মার্ট প্রগ্রেস ট্র্যাকিং সিস্টেম</li>
            <li><span class="cf-icon">✓</span> লাইভ কোর্স ও মডেল টেস্ট</li>
          </ul>
          <div class="cta-actions">
            <a href="https://play.google.com/store/apps/details?id=com.bcsprostuti.tanim.bcsprostuti" target="_blank" class="cta-play" @click="trackAppInstall">
              <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" height="48">
            </a>
            <a href="/packages" class="cta-pkg" @click="trackInitiateCheckout">প্যাকেজ দেখুন →</a>
          </div>
          <p class="cta-count">৯ লাখ+ শিক্ষার্থীর বিশ্বাসের অ্যাপ</p>
        </div>
        <div class="cta-right">
          <div class="cta-stat-card"><div class="cs-num">১৫</div><div class="cs-lbl">মোট মার্ক</div></div>
          <div class="cta-stat-card"><div class="cs-num">৩৫–৫০</div><div class="cs-lbl">বিসিএস বিশ্লেষণ</div></div>
          <div class="cta-stat-card"><div class="cs-num">২৪টি</div><div class="cs-lbl">টপিক কভারেজ</div></div>
          <div class="cta-stat-card"><div class="cs-num">৯ লাখ+</div><div class="cs-lbl">অ্যাপ ডাউনলোড</div></div>
        </div>
      </div>
    </div>
  </section>

  <WelcomeFooter :hide-download="true" />

  <MessengerFloat subject="science" />
</template>

<script>
import WelcomeHeader from "@/components/WelcomePages/WelcomeHeader.vue";
import WelcomeFooter from "@/components/WelcomePages/WelcomeFooter.vue";
import GuidelineNav from "@/components/WelcomePages/GuidelineNav.vue";
import GuidelineRelated from "@/components/WelcomePages/GuidelineRelated.vue";
import GuidelineOptin from "@/components/WelcomePages/GuidelineOptin.vue";
import MessengerFloat from "@/components/WelcomePages/MessengerFloat.vue";
import * as pixels from "@/config/pixels";
import { computed, onMounted } from 'vue';

export default {
  components: { WelcomeHeader, WelcomeFooter, GuidelineNav, GuidelineRelated, GuidelineOptin, MessengerFloat },
  setup() {
    // BCS columns: 35,36,37,38,40,41,43,44,45,46,47,50
    // (৩৯, ৪২, ৪৮, ৪৯ বিসিএসে সাধারণ বিজ্ঞানের পৃথক ডেটা নেই — তাই কলামে অন্তর্ভুক্ত নয়)
    const physicalScienceData = [
      { topic: 'বলবিদ্যা, শক্তির উৎস ও পরিমাপ', values: [0,2,2,1,1,1,0,0,2,1,0,2], total: 12, priority: 3 },
      { topic: 'জৈব ও অজৈব যৌগ',              values: [1,1,1,2,0,3,0,1,2,0,0,0], total: 11, priority: 3 },
      { topic: 'পরমাণুর গঠন',                  values: [1,0,0,0,1,0,1,0,2,1,0,1], total:  7, priority: 3 },
      { topic: 'মানব কল্যাণে রসায়ন',          values: [0,0,0,0,1,0,1,0,2,1,1,1], total:  7, priority: 2 },
      { topic: 'তড়িৎ',                        values: [1,0,0,0,1,1,1,1,0,0,0,2], total:  7, priority: 3 },
      { topic: 'রাসায়নিক বিক্রিয়া',           values: [0,0,1,0,1,0,1,1,0,1,1,0], total:  6, priority: 3 },
      { topic: 'এসিড, ক্ষার ও লবণ',            values: [1,0,0,0,0,2,0,1,0,1,1,0], total:  6, priority: 2 },
      { topic: 'আলোক শক্তি ও যন্ত্রপাতি',      values: [0,1,1,0,0,1,0,0,0,3,0,0], total:  6, priority: 2 },
      { topic: 'ভৌত বিজ্ঞানের উন্নয়ন',         values: [0,0,0,0,0,1,0,0,0,0,2,2], total:  5, priority: 2 },
      { topic: 'তাপ ও তাপগতিবিদ্যা',          values: [1,0,1,1,0,0,0,1,0,0,0,0], total:  4, priority: 2 },
      { topic: 'তরঙ্গ ও শব্দ',                 values: [0,0,1,0,0,0,0,0,1,0,3,0], total:  5, priority: 1 },
      { topic: 'চৌম্বকত্ব',                     values: [0,0,0,0,0,0,1,0,1,0,0,0], total:  2, priority: 1 },
      { topic: 'পদার্থের অবস্থা',              values: [0,0,0,0,1,0,0,0,0,0,0,0], total:  1, priority: 1 },
      { topic: 'ভৌত রাশি ও পরিমাপ',            values: [0,0,0,0,1,0,0,0,0,0,0,0], total:  1, priority: 1 },
    ];

    const lifeScienceData = [
      { topic: 'মানব দেহের অঙ্গ ও তন্ত্র',     values: [2,3,2,1,2,3,2,1,1,2,1,1], total: 21, priority: 3 },
      { topic: 'উদ্ভিদের শারীরবৃত্তীয় কাজ',    values: [1,0,0,0,2,0,1,1,0,0,0,0], total:  5, priority: 2 },
      { topic: 'কোষ',                          values: [0,1,0,0,1,0,0,0,1,1,0,1], total:  5, priority: 1 },
      { topic: 'জীব জগৎ',                      values: [1,0,1,0,0,0,0,0,0,1,0,1], total:  4, priority: 1 },
      { topic: 'টিস্যু',                       values: [2,0,0,0,0,0,0,0,0,0,0,0], total:  2, priority: 1 },
      { topic: 'পদার্থের জীববিজ্ঞান বিষয়ক ধর্ম', values: [0,0,0,1,0,0,0,0,0,1,0,0], total: 2, priority: 1 },
    ];

    const modernScienceData = [
      { topic: 'মাইক্রোবায়োলজি, রোগ ও স্বাস্থ্য', values: [0,3,2,4,0,0,2,5,2,2,3,3], total: 26, priority: 3 },
      { topic: 'পৃথিবী ও মহাবিশ্ব',            values: [1,2,3,4,0,3,1,2,1,0,2,1], total: 20, priority: 3 },
      { topic: 'মৌলিক কণা',                    values: [0,2,0,1,1,0,0,0,0,0,1,1], total:  6, priority: 2 },
      { topic: 'ইলেক্ট্রনিক্স',                 values: [0,0,0,0,2,0,1,1,0,0,0,0], total:  4, priority: 3 },
    ];

    const allData = computed(() =>
      [...physicalScienceData, ...lifeScienceData, ...modernScienceData].sort((a, b) => b.total - a.total)
    );
    const allChart = computed(() =>
      [...physicalScienceData, ...lifeScienceData, ...modernScienceData].sort((a, b) => b.total - a.total).slice(0, 10)
    );

    const refBooks = [
      { title: 'সাধারণ বিজ্ঞান (৯ম-১০ম শ্রেণি)', author: 'বোর্ড বই — প্রাসঙ্গিক অধ্যায়' },
      { title: 'পদার্থবিজ্ঞান (৯ম-১০ম শ্রেণি)', author: 'বোর্ড বই — প্রাসঙ্গিক অধ্যায়' },
      { title: 'রসায়ন (৯ম-১০ম শ্রেণি)', author: 'বোর্ড বই — প্রাসঙ্গিক অধ্যায়' },
      { title: 'জীববিজ্ঞান (৯ম-১০ম শ্রেণি)', author: 'বোর্ড বই — প্রাসঙ্গিক অধ্যায়' },
      { title: '৬ষ্ঠ–৮ম শ্রেণির বিজ্ঞান', author: 'বোর্ড বই — প্রাসঙ্গিক অধ্যায়' },
      { title: 'যে কোনো এক সেট গাইড বই', author: 'প্রশ্নের ধারণা ও নির্দেশনার জন্য' },
      { title: 'বিসিএস প্রস্তুতি অ্যাপ — বিজ্ঞান সেকশন', author: 'টপিকভিত্তিক প্রশ্ন ও ব্যাখ্যা' },
    ];

    const tips = [
      'প্রথমেই বিসিএস প্রস্তুতি অ্যাপ থেকে সাধারণ বিজ্ঞানের বিগত বছরের প্রশ্নগুলো ব্যাখ্যাসহ পড়ে ফেলুন — কী ধরনের প্রশ্ন আসে সে সম্পর্কে একটা সামগ্রিক ধারণা পাবেন।',
      'বিগত বছরের প্রশ্ন এনালাইসিস ভালোভাবে দেখুন এবং সেইভাবে বেসিক থেকে পড়ুন। সব পড়ার দরকার নেই — শুধু প্রাসঙ্গিক টপিকগুলো খুব ভালোভাবে পড়ুন। এরপর PSC-এর নেওয়া বিগত সকল প্রশ্ন ব্যাখ্যাসহ পড়ুন।',
      'টপিক অনুসারে বেসিক থেকে পড়াশোনা করুন। অ্যাপে সম্পূর্ণ বিজ্ঞান সেকশন আধুনিক বিজ্ঞান, ভৌত বিজ্ঞান ও জীববিজ্ঞান — টপিক/সাব-টপিক অনুসারে সাজানো আছে এবং স্মার্ট সিস্টেম আপনার প্রগ্রেস ট্র্যাক করবে।',
      'মনে রাখবেন — বিজ্ঞানে কোনো টপিক একদম বাদ দেওয়া নিরাপদ নয়। প্রতি বিসিএসেই কোনো না কোনো টপিক থেকে প্রশ্ন আসে, তাই সম্ভব হলে সব টপিকই কভার করুন।',
      'অনুশীলন শেষ হলে অ্যাপ থেকে যত খুশি বিষয়ভিত্তিক পরীক্ষা দিয়ে দুর্বলতা যাচাই করুন এবং গুরুত্বপূর্ণ বা ভুল প্রশ্ন মার্ক করে বার বার রিভিশন দিন।',
      'বিসিএস প্রস্তুতি অ্যাপের যে কোনো একটি লাইভ কোর্স (১২০ দিন বা ৬ মাস) ভালোভাবে ফলো করুন। ফাইনালের আগের ক্র্যাশ কোর্স ও মডেল টেস্ট অবশ্যই দিন।',
    ];

    // ── Helpers ──
    const toBengali = (n) => {
      const bn = ['০','১','২','৩','৪','৫','৬','৭','৮','৯'];
      return String(n).split('').map(c => bn[parseInt(c)] ?? c).join('');
    };
    const heatClass = (val) => { if (!val||val===0) return 'h0'; if (val===1) return 'h1'; if (val===2) return 'h2'; return 'h3'; };
    const priorityLabel = (p) => ({ 3:'★★★', 2:'★★', 1:'★' }[p]);

    // ── Funnel events (centralized in @/config/pixels) ──
    const trackAppInstall = () => pixels.trackAppInstallClick('science');
    const trackInitiateCheckout = () => pixels.trackInitiateCheckout('science');

    const setMeta = (attrs) => {
      const selector = attrs.property ? `meta[property="${attrs.property}"]` : `meta[name="${attrs.name}"]`;
      let el = document.querySelector(selector);
      if (!el) { el = document.createElement('meta'); document.head.appendChild(el); }
      Object.entries(attrs).forEach(([k,v]) => el.setAttribute(k,v));
    };

    onMounted(() => {
      window.scrollTo(0,0);
      document.title = 'সাধারণ বিজ্ঞান গাইডলাইন — টপিকভিত্তিক প্রশ্ন বিশ্লেষণ (৩৫–৫০ বিসিএস)';
      setMeta({name:'description', content:'বিসিএস ৩৫ থেকে ৫০ পর্যন্ত সাধারণ বিজ্ঞানের সম্পূর্ণ টপিকভিত্তিক প্রশ্ন বিশ্লেষণ। ভৌত বিজ্ঞান, জীববিজ্ঞান ও আধুনিক বিজ্ঞানের হিটম্যাপ, গুরুত্বপূর্ণ টপিক ও গাইডলাইন।'});
      setMeta({name:'keywords', content:'সাধারণ বিজ্ঞান গাইডলাইন, BCS Science, বিসিএস প্রস্তুতি, ভৌত বিজ্ঞান, জীববিজ্ঞান, আধুনিক বিজ্ঞান, রসায়ন'});
      setMeta({name:'robots', content:'index, follow'});
      setMeta({property:'og:title', content:'সাধারণ বিজ্ঞান গাইডলাইন — টপিকভিত্তিক প্রশ্ন বিশ্লেষণ'});
      setMeta({property:'og:description', content:'বিসিএস ৩৫–৫০ সাধারণ বিজ্ঞানের সম্পূর্ণ হিটম্যাপ বিশ্লেষণ।'});
      setMeta({property:'og:url', content:'https://www.bcsprostuti.com/science-guideline'});
      setMeta({property:'og:type', content:'article'});
      setMeta({property:'og:image', content:'https://www.bcsprostuti.com/og/science-guideline.jpg'});
      setMeta({property:'og:image:width', content:'1200'});
      setMeta({property:'og:image:height', content:'630'});
      setMeta({property:'og:image:alt', content:'সাধারণ বিজ্ঞান গাইডলাইন'});
      setMeta({property:'og:site_name', content:'বিসিএস প্রস্তুতি'});
      setMeta({name:'twitter:card', content:'summary_large_image'});
      setMeta({name:'twitter:title', content:'সাধারণ বিজ্ঞান গাইডলাইন — টপিকভিত্তিক প্রশ্ন বিশ্লেষণ'});
      setMeta({name:'twitter:description', content:'বিসিএস ৩৫–৫০ সাধারণ বিজ্ঞানের সম্পূর্ণ হিটম্যাপ বিশ্লেষণ।'});
      setMeta({name:'twitter:image', content:'https://www.bcsprostuti.com/og/science-guideline.jpg'});
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) { canonical = document.createElement('link'); canonical.rel='canonical'; document.head.appendChild(canonical); }
      canonical.href = 'https://www.bcsprostuti.com/science-guideline';
      pixels.trackGuidelineView('science');
      pixels.armViewedGuideline50('science');
    });

    return { physicalScienceData, lifeScienceData, modernScienceData, allData, allChart, refBooks, tips, toBengali, heatClass, priorityLabel, trackAppInstall, trackInitiateCheckout };
  }
};
</script>

<style scoped>
* { box-sizing: border-box; }

.hero-section { position: relative; background: linear-gradient(140deg,#191B47 0%,#0d0f2e 55%,#1a0828 100%); padding: 80px 0 60px; overflow: hidden; }
.hero-noise { position: absolute; inset: 0; pointer-events: none; background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.04'/%3E%3C/svg%3E"); }
.hero-inner { position: relative; text-align: center; }
.hero-badge { display: inline-block; background: rgba(0,149,255,0.15); border: 1px solid rgba(0,149,255,0.4); color: #0095FF; font-size: 0.8rem; font-weight: 600; padding: 6px 18px; border-radius: 999px; letter-spacing: 0.05em; margin-bottom: 20px; }
.hero-title { font-family: 'Noto Serif Bengali', serif; font-size: clamp(2rem,5vw,3.2rem); font-weight: 900; color: #fff; line-height: 1.25; margin-bottom: 16px; }
.hero-accent { background: linear-gradient(90deg,#0095FF,#00c6ff); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
.hero-sub { font-size: 1.05rem; color: #94a3b8; margin-bottom: 40px; }
.hero-stats { display: flex; align-items: center; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.12); border-radius: 16px; padding: 16px 20px; backdrop-filter: blur(12px); flex-wrap: wrap; justify-content: center; row-gap: 12px; }
.hstat { text-align: center; padding: 0 16px; }
.hstat-num { font-family: 'Noto Serif Bengali', serif; font-size: clamp(1.3rem,3vw,2rem); font-weight: 900; color: #0095FF; line-height: 1; }
.hstat-lbl { font-size: 0.72rem; color: #94a3b8; margin-top: 4px; }
.hstat-sep { width: 1px; height: 40px; background: rgba(255,255,255,0.15); flex-shrink: 0; }
@media(max-width:768px) { .hstat-sep { display: none; } .hstat { padding: 4px 12px; } }

/* marks bar */
.marks-bar { background: #191B47; padding: 20px 0; }
.marks-header { font-size: 0.75rem; font-weight: 700; color: #94a3b8; text-align: center; margin-bottom: 14px; letter-spacing: 0.05em; text-transform: uppercase; }
.marks-grid { display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; }
.mk-item { display: flex; flex-direction: column; align-items: center; background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.12); border-radius: 10px; padding: 10px 16px; min-width: 90px; }
.mk-num { font-family: 'Noto Serif Bengali', serif; font-size: 1.3rem; font-weight: 800; color: #0095FF; line-height: 1; }
.mk-lbl { font-size: 0.68rem; color: #94a3b8; margin-top: 5px; text-align: center; }

/* legend */
.legend-bar { background: #f8fafc; border-bottom: 1px solid #e2e8f0; padding: 10px 16px; overflow-x: auto; }
.legend-inner {
  display: flex; align-items: center; justify-content: flex-start; gap: 8px; font-size: 0.82rem; white-space: nowrap; min-width: max-content;
}
@media(min-width: 769px) {
  .legend-inner {
    justify-content: center;
    margin: 0 auto;
  }
}
.legend-label { font-weight: 700; color: #374151; margin-right: 4px; }
.lc { display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 26px; border-radius: 6px; font-size: 0.78rem; font-weight: 700; border: 1px solid #e2e8f0; }
.h0 { background: #f1f5f9; color: #94a3b8; }
.h1 { background: #fef9c3; color: #854d0e; }
.h2 { background: #fed7aa; color: #7c2d12; }
.h3 { background: #fca5a5; color: #7f1d1d; font-weight: 800; }
.legend-sep { color: #cbd5e1; margin: 0 4px; }
.pri-tag { font-size: 0.76rem; font-weight: 700; padding: 3px 10px; border-radius: 999px; }
.pri-tag.p3 { background: #fef2f2; color: #991b1b; }
.pri-tag.p2 { background: #fffbeb; color: #92400e; }
.pri-tag.p1 { background: #f0fdf4; color: #166534; }

/* main */
.main-section { padding: 40px 0; }
.tab-content {
  animation: fadeIn 0.2s ease;
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
}
@keyframes fadeIn { from { opacity:0; transform: translateY(6px); } to { opacity:1; transform: none; } }

/* chart */
.chart-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; padding: 28px 32px; margin-bottom: 40px; box-shadow: 0 2px 12px rgba(0,0,0,0.05); overflow: hidden; }
.chart-title { font-size: 1rem; font-weight: 700; color: #191B47; margin-bottom: 24px; }
.bar-list { display: flex; flex-direction: column; gap: 10px; }
.bar-row { display: flex; align-items: center; gap: 10px; }
.bar-label { font-size: 0.78rem; font-weight: 600; color: #374151; width: 170px; flex-shrink: 0; text-align: right; }
.bar-track { flex: 1; height: 22px; background: #f1f5f9; border-radius: 6px; overflow: hidden; }
.bar-fill { height: 100%; border-radius: 6px; transition: width 0.8s cubic-bezier(0.4,0,0.2,1); }
.bp3 { background: linear-gradient(90deg,#DC2626,#f87171); }
.bp2 { background: linear-gradient(90deg,#D97706,#fbbf24); }
.bp1 { background: linear-gradient(90deg,#059669,#34d399); }
.bar-val { font-family: 'Noto Serif Bengali', serif; font-size: 0.85rem; font-weight: 700; color: #191B47; width: 28px; text-align: right; }
@media(max-width: 600px) {
  .bar-row { flex-wrap: wrap; gap: 6px 8px; }
  .bar-label { width: 100%; text-align: left; font-size: 0.8rem; font-weight: 700; flex-shrink: 0; }
  .bar-track { flex: 1; min-width: 0; }
  .bar-val { width: 28px; flex-shrink: 0; }
  .chart-card { padding: 16px 12px; }
}

/* section head */
.section-head { margin-bottom: 20px; }
.section-head h2 { font-size: 0.95rem; font-weight: 700; color: #191B47; margin: 0 0 3px 0; border-left: 3px solid #0095FF; display: block; padding: 2px 0 2px 10px; }
.section-head p { color: #64748b; font-size: 0.8rem; margin: 0; padding-left: 13px; }
.section-head.center { text-align: center; }
.section-head.center h2 { border-left: none; padding-left: 0; font-size: 1.1rem; border-bottom: 3px solid #0095FF; display: inline-block; padding-bottom: 4px; }
.section-head.center p { padding-left: 0; margin-top: 8px; }

/* table */
.table-wrap {
  width: 100% !important;
  max-width: 100% !important;
  display: block !important;
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  -webkit-overflow-scrolling: touch !important;
  border-radius: 14px; box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  margin-bottom: 36px;
}
.table-wrap::-webkit-scrollbar {
  height: 6px;
  display: block;
}
.table-wrap::-webkit-scrollbar-track {
  background: #f1f5f9;
}
.table-wrap::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
.heat-table {
  width: 100% !important;
  max-width: none !important;
  min-width: 900px !important;
  border-collapse: collapse !important;
  font-size: 0.82rem; background: #fff;
}
.heat-table thead tr { background: #1e2a6e; }
.heat-table th { color: #e2e8f0; padding: 11px 7px; text-align: center; font-weight: 700; white-space: nowrap; font-size: 0.76rem; border-right: 1px solid rgba(255,255,255,0.1); }
.heat-table th.t-topic {
  text-align: left; padding-left: 16px; min-width: 175px; color: #fff;
  position: sticky; left: 0; background: #1e2a6e !important; z-index: 3;
  pointer-events: none;
  overflow: hidden; text-overflow: ellipsis; max-width: 175px;
}
@media(max-width: 768px) {
  .heat-table th.t-topic {
    min-width: 130px !important;
    max-width: 130px !important;
    padding-left: 8px;
  }
}
.heat-table th.t-new { background: #0095FF; color: #1a1a1a; }
.heat-table th.t-total { background: #1d4ed8; color: #fff; min-width: 50px; }
.heat-table th.t-pri { background: #6d28d9; color: #fff; min-width: 80px; }
.heat-table td { padding: 7px 6px; text-align: center; border-bottom: 1px solid #f1f5f9; font-size: 0.8rem; font-family: 'Noto Serif Bengali', serif; }
.heat-table tbody tr:hover td { filter: brightness(0.96); }
.heat-table td.t-name {
  text-align: left !important; padding-left: 14px; font-weight: 600; color: #1e293b; white-space: nowrap; font-size: 0.8rem; font-family: system-ui, -apple-system, sans-serif;
  position: sticky; left: 0; background: #fff !important; z-index: 2;
  box-shadow: 2px 0 5px rgba(0,0,0,0.05);
  pointer-events: none;
  overflow: hidden; text-overflow: ellipsis; max-width: 175px;
}
@media(max-width: 768px) {
  .heat-table td.t-name {
    min-width: 130px !important;
    max-width: 130px !important;
    padding-left: 8px;
    font-size: 0.75rem;
  }
}
.t-total-cell { background: #eff6ff; color: #1e40af; font-weight: 700; }
.t-pri-cell { background: #faf5ff; }
.pb { display: inline-block; padding: 3px 9px; border-radius: 999px; font-size: 0.72rem; font-weight: 800; font-family: system-ui, -apple-system, sans-serif; }
.pb.p3 { background: #fef2f2; color: #991b1b; }
.pb.p2 { background: #fffbeb; color: #92400e; }
.pb.p1 { background: #f0fdf4; color: #166534; }

/* insight */
.insight-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 16px; margin-bottom: 32px; }
@media(max-width:768px) { .insight-grid { grid-template-columns: 1fr; } }
.ins-card { border-radius: 14px; padding: 22px 20px; text-align: left; }
.ins-head { font-weight: 800; font-size: 0.9rem; margin-bottom: 14px; text-align: left; }
.ins-card ul { padding-left: 18px; margin: 0; text-align: left; }
.ins-card li { font-size: 0.88rem; margin-bottom: 7px; color: #374151; text-align: left; word-break: break-word; }
.ins-card.must { background: #fef2f2; border: 1px solid #fecaca; }
.ins-card.must .ins-head { color: #991b1b; }
.ins-card.imp { background: #fffbeb; border: 1px solid #fde68a; }
.ins-card.imp .ins-head { color: #92400e; }
.ins-card.low { background: #f0fdf4; border: 1px solid #bbf7d0; }
.ins-card.low .ins-head { color: #166534; }

/* analysis */
.analysis-box { background: #f0f9ff; border-left: 4px solid #191B47; border-radius: 0 14px 14px 0; padding: 20px 24px; margin-bottom: 48px; text-align: left; }
.analysis-box h4 { font-size: 1rem; font-weight: 700; color: #191B47; margin-bottom: 10px; }
.analysis-box p { font-size: 0.9rem; color: #374151; margin-bottom: 10px; line-height: 1.7; }
.mb-0 { margin-bottom: 0; }

/* ref books */
.ref-section { background: #f8fafc; padding: 48px 0; }
.book-grid { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 12px; margin-top: 28px; width: 100%; }
@media(max-width:768px) { .book-grid { grid-template-columns: repeat(2,1fr); } }
@media(max-width:480px) { .book-grid { grid-template-columns: 1fr; } }
.book-card { display: flex; align-items: stretch; border-radius: 10px; overflow: hidden; border: 1px solid #e2e8f0; background: #fff; box-shadow: 0 2px 6px rgba(0,0,0,0.04); transition: transform 0.18s; }
.book-card:hover { transform: translateY(-2px); box-shadow: 0 6px 18px rgba(0,0,0,0.09); }
.book-spine { width: 5px; background: linear-gradient(180deg,#191B47,#312e81); flex-shrink: 0; }
.book-info { padding: 12px 14px; display: flex; flex-direction: column; justify-content: center; text-align: left; }
.book-title { font-size: 0.82rem; font-weight: 700; color: #1e293b; margin-bottom: 3px; line-height: 1.4; }
.book-author { font-size: 0.74rem; color: #64748b; }

/* tips */
.tips-section { background: #fff; padding: 48px 0; }
.tips-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 12px; margin-top: 28px; }
@media(max-width:600px) { .tips-grid { grid-template-columns: 1fr; } }
.tip-card { display: flex; gap: 16px; align-items: flex-start; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 14px; padding: 20px; }
.tip-num { width: 32px; height: 32px; border-radius: 50%; background: #fff; color: #191B47; border: 2px solid #191B47; display: flex; align-items: center; justify-content: center; font-family: 'Noto Serif Bengali', serif; font-weight: 800; font-size: 0.85rem; flex-shrink: 0; }
.tip-text { font-size: 0.9rem; color: #374151; line-height: 1.7; margin: 0; text-align: left; }

/* CTA */
.cta-section { background: #191B47; border-top: 4px solid #0095FF; padding: 64px 0; }
.cta-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; }
@media(max-width:768px) { .cta-grid { grid-template-columns: 1fr; gap: 32px; } }
.cta-left { align-self: center; }
.cta-tag { display: inline-block; font-size: 0.72rem; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; color: #0095FF; background: rgba(0,149,255,0.15); border: 1px solid rgba(0,149,255,0.35); padding: 4px 14px; border-radius: 999px; margin-bottom: 14px; }
.cta-title { font-family: 'Noto Serif Bengali', serif; font-size: 1.5rem; font-weight: 800; color: #fff; line-height: 1.4; margin-bottom: 20px; }
.cta-features { list-style: none; padding: 0; margin: 0 0 24px 0; display: flex; flex-direction: column; gap: 9px; }
.cta-features li { display: flex; align-items: center; gap: 10px; font-size: 0.88rem; color: #c7d2fe; }
.cf-icon { width: 20px; height: 20px; background: rgba(0,149,255,0.2); color: #0095FF; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; font-size: 0.7rem; font-weight: 800; flex-shrink: 0; }
.cta-actions { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 16px; }
.cta-play { display: inline-flex; align-items: center; background: #fff; border-radius: 10px; padding: 7px 16px; text-decoration: none; transition: transform 0.2s; }
.cta-play:hover { transform: scale(1.03); }
.cta-pkg { display: inline-flex; align-items: center; background: #0095FF; color: #1a1a1a; font-weight: 700; font-size: 0.9rem; border-radius: 10px; padding: 11px 24px; text-decoration: none; transition: all 0.2s; }
.cta-pkg:hover { background: #007AD6; transform: scale(1.02); }
.cta-count { font-size: 0.78rem; color: #64748b; margin: 0; }
.cta-right { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; align-self: center; }
@media(max-width:768px) { .cta-right { grid-template-columns: repeat(2, 1fr); gap: 10px; } }
.cta-stat-card { background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.14); border-radius: 14px; padding: 24px 20px; text-align: center; }
.cs-num { font-family: 'Noto Serif Bengali', serif; font-size: 1.6rem; font-weight: 800; color: #0095FF; line-height: 1.1; }
.cs-lbl { font-size: 0.75rem; color: #94a3b8; margin-top: 7px; }
</style>